
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/contact-lists",
      function () {
        return require("private-next-pages/account/contact-lists/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/contact-lists"])
      });
    }
  